<template>
    <div class="cf-c-video-player" :style="boxStyle">
        <iframe
            ref="video"
            class="cf-c-video-player__frame"
            :src="embedSrc"
            :style="{ maxWidth: `${(height * 16) / 9}px` }"
            frameborder="0"
            allowfullscreen
        ></iframe>
    </div>
</template>

<script>
import { Player } from '@gumlet/player.js'

// Same player options the other Advisera systems use for Gumlet embeds
const GUMLET_PLAYER_PARAMS = [
    'preload=true',
    'disabled_player_control=rewind',
    'disabled_player_control=fast-forward',
    'disabled_player_control=current-time',
    'disabled_player_control=duration',
    'disabled_player_control=captions',
    'disabled_player_control=pip',
    'disabled_player_control=download',
    'disabled_player_control=cast',
    'player_color=%2300000059'
]

export default {
    props: {
        src: {
            type: String,
            required: true
        },

        width: {
            type: Number,
            required: false,
            default: null
        },

        height: {
            type: Number,
            required: false,
            default: 360
        }
    },

    data () {
        return {
            player: null
        }
    },

    computed: {
        boxStyle () {
            return {
                width: this.width ? `${this.width}px` : null,
                height: `${this.height}px`
            }
        },

        embedSrc () {
            const separator = this.src.includes('?') ? '&' : '?'

            return this.src + separator + GUMLET_PLAYER_PARAMS.join('&')
        }
    },

    watch: {
        embedSrc () {
            // Player.js binds to the iframe's origin and src when it is created
            this.$nextTick(this.createPlayer)
        }
    },

    mounted () {
        this.createPlayer()
    },

    beforeDestroy () {
        this.destroyPlayer()
    },

    methods: {
        createPlayer () {
            this.destroyPlayer()

            if (!this.$refs.video) {
                return
            }

            const player = new Player(this.$refs.video)

            player.on('ready', () => {
                player.on('play', () => {
                    this.$emit('play')
                })

                this.$emit('ready')
            })

            this.player = player
        },

        destroyPlayer () {
            if (this.player) {
                this.player.destroy()
                this.player = null
            }
        }
    }
}
</script>

<style lang="scss">
// Same box as the old Vimeo iframe (300px default width, given height). Gumlet pins the video
// to the top of a frame that is not 16:9, so the 16:9 frame is centred in the box the way
// Vimeo letterboxed it. Not scoped, so wrappers such as .cf-c-about can still set the width.
.cf-c-video-player {
    // inline-block + overflow puts the baseline at the bottom edge, like the old inline iframe
    display: inline-block;
    overflow: hidden;
    width: 300px;
}

.cf-c-video-player__frame {
    position: relative;
    top: 50%;
    display: block;
    width: 100%;
    margin: 0 auto;
    aspect-ratio: 16 / 9;
    border: 0;
    transform: translateY(-50%);
}
</style>
